// extracted by mini-css-extract-plugin
module.exports = {"more":"more___21GgD","icon":"icon___O8gKq"};